import React from 'react'

const RoadMap = () => {
    return (
        <section className="relative py-16 border-b border-ebony-300">
            <div className="container lg:px-36">
                <div className="mx-auto">
                    <div className="pb-20">
                        <h2 className="text-lg font-semibold text-center lg:text-5xl text-gray-50 lg:px-20 leading-tighter">Product roadmap</h2>
                        <p className="mt-6 text-center text-ebony-300">Lorem ipsum dolor sit amet, cectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</p>
                    </div>
                    <div className="px-8">
                        <div className="grid grid-cols-2 gap-0 mx-auto">
                            <div className="border-r h-36 border-ebony-300 ">
                                <span className="flex h-3 w-3 relative left-full -ms-1.5">
                                    <span className="absolute inline-flex w-full h-full bg-blue-400 rounded-full opacity-75 animate-ping"></span>
                                    <span className="relative inline-flex w-3 h-3 bg-blue-500 rounded-full"></span>
                                </span>
                                <div className="">
                                    <div className="text-ebony-300 iv u sj greveal-y is-revealed">Deployed a high-quality first release and conducted a market validation test</div>
                                </div>
                            </div>
                            <div></div>
                            <div className="border-r h-36 border-ebony-300"></div>
                            <div className="h-36">
                                <div className="relative px-6 h-36">
                                    <span className="flex h-3 w-3 absolute right-full -mr-1.5">
                                        <span className="absolute inline-flex w-full h-full bg-blue-400 rounded-full opacity-75 animate-ping"></span>
                                        <span className="relative inline-flex w-3 h-3 bg-blue-500 rounded-full"></span>
                                    </span>
                                    <div className="text-ebony-300 iv u sj greveal-y is-revealed">Deployed a high-quality first release and conducted a market validation test</div>
                                </div>
                            </div>
                            <div></div>
                            <div></div>
                            <div className="border-r h-36 border-ebony-300">
                                <div className="relative h-36">
                                    <span className="flex h-3 w-3 absolute left-full -ms-1.5">
                                        <span className="absolute inline-flex w-full h-full bg-blue-400 rounded-full opacity-75 animate-ping"></span>
                                        <span className="relative inline-flex w-3 h-3 bg-blue-500 rounded-full"></span>
                                    </span>
                                    <div className="text-ebony-300 iv u sj greveal-y is-revealed">Deployed a high-quality first release and conducted a market validation test</div>
                                </div>
                            </div>
                            <div></div>
                            <div className="border-r h-36 border-ebony-300"></div>
                            <div className="h-36">
                                <div className="relative px-8">
                                    <span className="flex h-3 w-3 absolute right-full -mr-1.5">
                                        <span className="absolute inline-flex w-full h-full bg-blue-400 rounded-full opacity-75 animate-ping"></span>
                                        <span className="relative inline-flex w-3 h-3 bg-blue-500 rounded-full"></span>
                                    </span>
                                    <div className="text-ebony-300 iv u sj greveal-y is-revealed">Deployed a high-quality first release and conducted a market validation test</div>
                                </div>
                            </div>
                            <div></div>
                            <div></div>
                            <div className="h-36 ">
                                <div className="relative h-36">
                                    <span className="flex h-3 w-3 absolute left-full -ms-1.5 ">
                                        <span className="absolute inline-flex w-full h-full bg-blue-400 rounded-full opacity-75 animate-ping"></span>
                                        <span className="relative inline-flex w-3 h-3 bg-blue-500 rounded-full"></span>
                                    </span>
                                    <div className="text-ebony-300 iv u sj greveal-y is-revealed">Deployed a high-quality first release and conducted a market validation test</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default RoadMap
